/**
 * Shared config and options for product detail (catalog + cart edit).
 * Used by ProductDetailModal (catalog list and cart view/edit).
 */

const CONFIG_KEYS = [
  "height",
  "width",
  "depth",
  "external_color",
  "internal_color",
  "carcass_material",
  "shutter_material",
];

export const emptyConfig = () =>
  CONFIG_KEYS.reduce((acc, k) => ({ ...acc, [k]: "" }), {});
